// TODO: set types dynamically from server...
// TODO: right now the enum value MUST match the name of the type from the server
enum OrganizationType {
  NonProfit = 'Nonprofit',
  ForProfit = 'For Profit',
  Public = 'Public / Government Entity',
}

export default OrganizationType;
